export const business = [
    {
        id: "content-business-latest-trends",
        name: "آخر الصيحات",
        articles: [
            {
                id: "addec243-95e5-4aae-8261-c6b82b928293",
                class: "columns-3-wide",
                header: "الاستثمار",
                url: "#",
                carousel: {
                    width: "684",
                    height: "385",
                    images: [
                        {
                            id: "038a6c60-3006-470b-9d93-323c1c585cf7",
                            src: "assets/images/maxim-hopman-IayKLkmz6g0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "25d59bcd-4740-48d3-921d-d4856317a848",
                            src: "assets/images/joshua-rawson-harris-KRELIShKxTM-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "58880bc6-deea-46fc-8637-02f515e81469",
                            src: "assets/images/martin-sanchez-z2v23KWm5D0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "28b22171-338a-4ada-b87e-84a7bb42c3a3",
                            src: "assets/images/nasa-1lfI7wkGWZ4-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "2587289d-eece-4001-b39e-aecfbd4a4253",
                            src: "assets/images/thomas-scott-yASysTwq-Is-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                    ],
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
            },
            {
                id: "4d5bbeee-9e05-4f95-b6bf-af41b145e4e3",
                class: "columns-3-narrow",
                header: "وسائط",
                url: "#",
                image: {
                    src: "assets/images/glenn-carstens-peters-npxXWgQ33ZQ-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "حامل في الاحماء والرعاية.الواجبات المنزلية المختلفة في لوريم الرئيسية حتى نصائح الكتلة.",
                type: "text",
                content: "فكان اليها مع الا. أخذ إذ انتهت وباستثناء. لم وزارة موالية كان. دار من أثره، مدينة وبغطاء, ٣٠ أخذ قادة استراليا،. يقوم المتّبعة في جُل, عدم مسرح كُلفة عن.",
            },
            {
                id: "a788ad50-9e3a-461e-be18-828fbce1dbd9",
                class: "columns-3-narrow",
                header: "أفكار",
                url: "#",
                image: {
                    src: "assets/images/kenny-eliason-4N3iHYmqy_E-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "وعاء لزج يعمل الآن.الأهم من ذلك المطور الواجب المنزلي الرعاية الحزينة.",
                type: "text",
                content:
                    "تم وتم اعتداء واتّجه العمليات, حيث حالية المضي عل. عن أمدها الوراء أضف, عل حكومة بالولايات الى, أم الحرة ولاتّساع ذلك. من فسقط بوابة والفرنسي بال, ألمّ الأرواح ومحاولة كل هذه, في جنوب أوروبا على. ببعض أمام أراضي من أما. بها ٠٨٠٤ ومضى ان, الأحمر بريطانيا التقليدي ثم ذات. هو وزارة اليميني عدم, ان ممثّلة الثانية الا.",
            },
        ],
    },
    {
        id: "content-business-market-watch",
        name: "مراقبة السوق",
        articles: [
            {
                id: "ed902471-e96d-462b-bc88-01c7e22d5fa0",
                class: "columns-3-balanced",
                header: "الشائع",
                image: {
                    src: "assets/images/anne-nygard-tcJ6sJTtTWI-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "كل جزر الفلفل الحار.",
                type: "text",
                content:
                    "الدمج الخاصّة أفريقيا حول أي, التبرعات العالمية يكن ما. الحدود أفريقيا وأكثرها غير ٣٠, المضي الصين أي غير. تسمّى مشارف كل وفي, الا الحرة بالمطالبة تم. جزيرتي لتقليعة ثم تعد, يتم من حاملات الضروري. صفحة لعدم أوزار كل الا, لها ثم اليابان استطاعوا.",
            },
            {
                id: "31a8663a-d035-4b62-adeb-195a1c60e831",
                class: "columns-3-balanced",
                header: "تقنية",
                image: {
                    src: "assets/images/truckrun-XBWF6_TEsFM-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ضع مهنة سريرية.",
                type: "text",
                content:
                    "بـ أواخر ويتّفق مسؤولية ذات, وجزر الإتحاد ما عرض. مشارف الأثناء، كما بـ, ما وتم أواخر شموليةً والفلبين. هذه ضمنها بلديهما الجنرال عن, وقد ثم جورج معزّزة الاندونيسية, معزّزة استرجاع و جُل. هو الشتوية عسكرياً يبق, مارد بالتوقيع و أسر. شدّت أثره، ذلك ٣٠, ما تلك سقطت مكثّفة للأراضي.",
            },
            {
                id: "bf9491d2-ffcc-4ed3-a3a4-2cfda792f06b",
                class: "columns-3-balanced",
                header: "نجاح",
                image: {
                    src: "assets/images/alex-hudson-7AgqAZbogOQ-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "تخمير الشوكولاتة من وثيقة الهوية الوحيدة الحلق في.",
                type: "text",
                content:
                    "أدوات وقوعها، العسكري قد مدن, قد قبل واحدة الأهداف, فصل إذ ونتج سكان جسيمة. دول تجهيز وأزيز باستحداث بـ, كما و هُزم قامت. انتهت وحرمان ٣٠ بلا. بال ثم مسرح المبرمة, يعبأ أملاً أن حدى, تعد لعدم منتصف في. كرسي الجنرال ايطاليا، وفي ثم, أضف النفط التخطيط و, بل شيء أهّل الساحل تزامناً.",
            },
        ],
    },
    {
        id: "content-business-economy-today",
        name: "الاقتصاد اليوم",
        articles: [
            {
                id: "95d5859b-44d0-452b-adba-52af428c9b8e",
                class: "columns-wrap",
                header: "التأثير العالمي",
                type: "excerpt",
                content: [
                    {
                        id: "1f074185-0c72-47cc-b889-2b0d5be855eb",
                        image: {
                            src: "assets/images/chris-leboutillier-TUJud0AWAPI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "الى هو العناد اوروبا الولايات. لم هُزم الدول وقدّموا حين, وبلجيكا، بالولايات أم غير. غير أوسع الضروري الفرنسية في, نفس بـ مايو وسفن الستار. قررت قُدُماً ان على. عن تلك إجلاء قائمة, جُل هو العناد العاصمة الأعمال. عل حول وتزويده ويكيبيديا المشتّتون, فصل تكبّد يونيو كل.",
                    },
                    {
                        id: "5ba10ec7-2031-4e61-98c4-4fa2e681c0e2",
                        image: {
                            src: "assets/images/nasa-Q1p7bh3SHj8-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "لم يونيو وبولندا ولم, ما معاملة ألمانيا يكن. كما هو العظمى واشتدّت المشتّتون, محاولات الصينية حدى كل. شيء أي المارق ومحاولة, الا تحرّكت البشريةً المتاخمة عل. لان الأولى ولكسمبورغ قد, بلا الدول يتبقّ الأحمر إذ, بالعمل استبدال قد بلا. مكن للجزر الجنود والفرنسي ٣٠, عرفها وبغطاء دار ان.",
                    },
                    {
                        id: "8534ba50-7daa-43da-ab5e-929b06ee127f",
                        image: {
                            src: "assets/images/markus-spiske-Nph1oyRsHm4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "اتفاق لإنعدام بل ذلك, بـ لهذه لفرنسا بال, دار إذ اللا المحيط. جعل الثقيل الأمريكي هو, أن شدّت أراضي قبضتهم به،, بـ قدما الجوي مكن. كان لم بالسيطرة لبولندا،, تلك ما لغزو مليارات. أم الأرض وتنصيب التجارية أخذ, تم جعل قِبل مسارح ليرتفع.",
                    },
                ],
            },
            {
                id: "f89eb533-713d-4ece-9998-c29672199357",
                class: "columns-wrap",
                header: "الآفاق",
                type: "excerpt",
                content: [
                    {
                        id: "c9e71431-0407-4329-bbb3-61a820dc636a",
                        image: {
                            src: "assets/images/denys-nevozhai-z0nVqfrOqWA-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قد ا العاصمة يتم, الذود الخاطفة قد ذات. عن وفي تجهيز منتصف مسؤولية, تعداد الشّعبين مما عل, أخر الواقعة باستحداث اقتصادية إذ. ان الأراضي الدولارات دار. على الذود ليرتفع البولندي مع. بلا كثيرة ديسمبر كل, في أما أثره، أجزاء وتزويده, أن نهاية والكوري ذات.",
                    },
                    {
                        id: "d0c42c8e-e4a5-46b7-a7a7-9e3e8dfb34a3",
                        image: {
                            src: "assets/images/taylor-grote-UiVe5QvOhao-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "خيار البشريةً ذلك مع. حين شمال بالجانب المعاهدات مع, شيء أحكم وشعار بل, يكن إستيلاء التقليدية في. إذ مارد وزارة الولايات كان, ولم قد الصعداء الأمريكية. للمجهود بالجانب الصعداء تم دول.",
                    },
                    {
                        id: "c3bbf9c0-e133-405b-8a1b-e24da3258980",
                        image: {
                            src: "assets/images/linkedin-sales-solutions--AXDunSs-n4-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بشرية المشترك باستخدام هو وصل. سكان عرفها ان كلّ. أن حول وسمّيت لليابان ألمانيا. كان ٣٠ إعادة للسيطرة الأوضاع.",
                    },
                ],
            },
            {
                id: "eb628ced-8e49-4cc7-a4b6-2531bc5f7b30",
                class: "columns-wrap",
                header: "الحرية المالية",
                type: "excerpt",
                content: [
                    {
                        id: "bc0da085-5ade-493d-8784-78ae2607cf29",
                        image: {
                            src: "assets/images/tierra-mallorca-rgJ1J8SDEAY-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "رئيس هُزم الأجل كل أخذ, سقوط العاصمة ما كلّ, وفي دارت هنا؟ العسكري تم. إعمار لعملة المزيفة عن جعل, فعل في قتيل، السيطرة. العظمى الهادي كل مما, من إيو إعادة معارضة بولندا،. بلاده العدّ المتحدة عن جعل, بلا مع مرمى وبعدما الطريق. بـ دول الثالث، الأوربيين, بلا في رئيس اقتصادية, قام ثم عرفها هاربر. بحث ويتّفق العالمية ثم, بل يتبقّ بالفشل تعد, أن ومن لهذه تنفّس. ان هذا الجوي الأوروبي.",
                    },
                    {
                        id: "9ae84ec2-229d-4969-870a-23e8561146ef",
                        image: {
                            src: "assets/images/stephen-phillips-hostreviews-co-uk-em37kS8WJJQ-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أي مدن كردة بالحرب الأوروبيّون, ٣٠ دون ليبين لهيمنة الأراضي. مع فاتّبع الشمال حين. مساعدة ماليزيا، أم حيث, عليها المنتصر نفس إذ. ثم دفّة ترتيب يكن, تم العناد بمباركة الإيطالية أما.",
                    },
                    {
                        id: "8b9e5c03-b566-4e78-9df3-768698a17713",
                        image: {
                            src: "assets/images/roberto-junior-4fsCBcZt9H8-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "معقل الشهير به، بـ, أدوات استرجاع وبريطانيا عل ذلك, هو دار لفرنسا مهمّات ومطالبة. كل جسيمة أوراقهم وفي. ماذا معقل ومحاولة دار في, كل كلا وقبل صفحة انتهت. مكن تصفح وجزر بقيادة من, الأهداف ولاتّساع حيث عن, لان وصغار المشتّتون بل. وبدون الصفحة إذ أخر, لها الذود السفن قد. قد بحق مقاطعة التقليدي التجارية. مع إيو رئيس لليابان, فقد عن أحكم للحكومة.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-must-read",
        name: "يجب أن يقرأ",
        articles: [
            {
                id: "b77172cc-4e49-40ca-9235-eb2f5f865804",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "75dba799-f4f1-43d7-909c-81e107a61281",
                        image: {
                            src: "assets/images/carl-nenzen-loven-c-pc2mP7hTs-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "هو كنقطة معارضة الرئيسية وقد, ومن لم مايو جديدة. المسرح بالسيطرة ماليزيا، قبل ما, يتمكن بتخصيص الإطلاق إذ كلّ. تعداد الأثنان ومن كل. سليمان، المزيفة تحت بـ.",
                        url: "#",
                    },
                    {
                        id: "7d882247-3db1-4882-a609-ee5eed6dc6df",
                        image: {
                            src: "assets/images/devi-puspita-amartha-yahya-7ln0pST_O8M-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "أم قام شمال الدولارات, إذ عدم تكبّد استبدال, بال الطرفين واستمرت ما. ارتكبها الأثناء، مع وتم, نفس ان هنا؟ سقطت انتهت. على مع نتيجة القوى الفرنسية, أسابيع والمعدات الأوروبيّون يتم ما. مع كان قدما مسارح واتّجه, الأمور ليرتفع استعملت قد لها, بتخصيص الإمداد ان وصل. بعد زهاء ومحاولة مع, ذلك هنا؟ أراضي العصبة و. لمّ جيوب لغزو الجو أن. إذ على ألمّ إختار, أم بعض الفرنسي اليابان،.",
                        url: "#",
                    },
                    {
                        id: "de04fa72-d96e-4eb7-bbf7-d587e31a5f6b",
                        image: {
                            src: "assets/images/bernd-dittrich-Xk1IfNnEhRA-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "لم اللا الآخر الثقيل الا. ٣٠ الأول بالرّد حول, وجزر مليون السبب شيء أي. بعد أي بحشد للجزر اليها, جمعت جيما مسارح مكن ثم. تم لان نقطة وسفن, حاول الجو واعتلاء كل عرض. بل نفس وبدأت وتتحمّل.",
                        url: "#",
                    },
                    {
                        id: "d6275634-2236-4a3c-b787-a71d33ae5bdf",
                        image: {
                            src: "assets/images/crystal-kwok-xD5SWy7hMbw-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "بالرّد التاريخ، تم يتم, وبداية الإطلاق دار في, ان أما بهيئة ويتّفق الأثناء،. عدم أن بفرض لفشل الفرنسي, عن بهيئة أمدها الفرنسي جعل, كل بعد لأداء ويتّفق التاريخ،. بتطويق الخاسرة بالمطالبة مع الا. ليبين اليابان، ما عدد. وتزويده استراليا، تشيكوسلوفاكيا شيء قد.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-educational",
        name: "تعليمية",
        articles: [
            {
                id: "4187d9c9-e176-4b0a-8bee-03f4f3be418a",
                class: "columns-3-balanced",
                header: "الأعمال 101",
                image: {
                    src: "assets/images/austin-distel-rxpThOwuVgE-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "dictumst كل جزر الفلفل الحار.",
                type: "text",
                content:
                    "فمرّ وأزيز مساعدة يبق بل. الحكم الجنوب حتى في, بقسوة والقرى بمحاولة بحث ثم, ٣٠ مسارح فقامت الشتوية إيو. الا غرّة، يتسنّى اليابان في, و بداية وإعلان التكاليف لان. المدن لإعادة أما تم, لمّ قامت المنتصر الواقعة عن.\n\nمدن دفّة هاربر اعلان و. يكن تحرّك الإنذار، أن. ووصف المواد الواقعة ضرب إذ. لمّ مع تعديل تحرّكت وبولندا, نفس قد وحتّى مساعدة الأراضي. حصدت وصغار بريطانيا، الى أن, حكومة أساسي واستمرت ما وفي.",
            },
            {
                id: "c519abd4-bb39-4b35-b3fb-130713f8f27b",
                class: "columns-3-balanced",
                header: "بدء",
                image: {
                    src: "assets/images/memento-media-XhYq-5KnxSk-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "دول نتيجة أوروبا عن. بين أحكم المشترك من, لم فرنسية أوروبا",
                type: "text",
                content:
                    "إذ فهرست الدّفاع التغييرات عدد, مع المدن والديون الجديدة، مدن. قام أم أمّا عسكرياً. جنوب الصفحات مع أما. مواقعها الإحتفاظ التبرعات هذه تم, شرسة الأمم بالإنزال أخذ و.\n\nثم تحرّك بالإنزال يكن, عل حول غضون الأمريكي. ان هذه ليرتفع الأثناء،. عل أضف أمام بولندا، استمرار. مكن ثم يعادل اتفاقية, لان تمهيد الجنوبي والروسية من. بال أمام بخطوط الأعمال بـ, قبل مايو والفرنسي ان. ومن من الغالي والديون الإيطالية, ماذا تكاليف البشريةً عل لكل. أي تصرّف قائمة وعُرفت أضف, أن ولم أخرى ابتدعها.",
            },
            {
                id: "a7b41785-e2d9-4afa-a161-5edcffce77a8",
                class: "columns-3-balanced",
                header: "تحقيق الربح",
                image: {
                    src: "assets/images/austin-distel-97HfVpyNR1M-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "تخمير الشوكولاتة من وثيقة الهوية الوحيدة الحلق في.",
                type: "text",
                content:
                    "ذات كل فبعد الثقيل, كما فكان وبحلول المشتّتون إذ, عرض فبعد أثره، وبغطاء هو. ما قام شاسعة تحرّك اوروبا. انه إذ سياسة الأحمر الحدود. ساعة تجهيز أن كان. جمعت اليابان لبلجيكا، ٣٠ دول, غضون شعار العسكري ان أسر. وبدون يرتبط ثم جُل, حيث تغييرات التكاليف أن.\n\nالأخذ الجنوب بالتوقيع من بحق, معقل الواقعة ٣٠ تحت, الصعداء وأكثرها دار هو. أخذ أمّا يتبقّ ما. المحيط للإتحاد قد حدى, تم عدد وشعار الأرواح. أخذ ٢٠٠٤ الجنود الأرضية ما, قد حكومة تجهيز العمليات مكن, وتنصيب المنتصر مع نفس. من وبولندا الإتحاد عدم, أخذ قد دارت شدّت, بال ان الإكتفاء التغييرات.",
            },
        ],
    },
    {
        id: "content-business-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "4e229873-04c6-410a-a433-18178fa4aad5",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "a623eb53-c205-4ba7-88cc-7d28a402fbe7",
                        image: {
                            src: "assets/images/bruce-mars-xj8qrWvuOEs-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "نفس فمرّ الدنمارك ان, أسر ثم عملية الشرقي. كل قررت غرّة، ذلك, هو ابتدعها والمانيا بالتوقيع هذا. من يعبأ شرسة الآلاف هذا, جنوب يذكر لمّ أم, لدحر أوسع العسكري لها عن. قبضتهم وعُرفت لم هذا, تم عدم سابق أواخر بالسيطرة. أي جيما الأمريكي أسر, كان يعبأ للمجهود والعتاد ان. مع أمدها الهادي الولايات كما, ولم التي انتصارهم ان, لأداء إتفاقية أن حيث.",
                        url: "#",
                    },
                    {
                        id: "5a406442-2994-47c1-9e9c-51ccb2c12dbc",
                        image: {
                            src: "assets/images/ryan-plomp-TT6Hep-JzrU-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "كان مسارح الساحة ثم. تم عرفها وباءت الوراء مما, إذ بتخصيص الأبرياء لمّ, ومن في الجنود إستيلاء. في بلا واعتلاء واندونيسيا،, قام عن دارت ليركز الستار. تكبّد ويعزى الإيطالية بـ وصل.",
                        url: "#",
                    },
                ],
            },
            {
                id: "1760d2cf-9530-4c27-9943-ec0525b5dd4f",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "12d94ea1-157a-4f3d-87bf-28c305b52aea",
                        image: {
                            src: "assets/images/robert-bye-xHUZuSwVJg4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "و تحت عُقر ابتدعها, أضف أم الأثنان الإحتفاظ. حاول مدينة لم جهة. إعلان فهرست واُسدل يتم بل, كلا في الجو إحكام, و دخول اللازمة بالمطالبة به،. التي وجهان وسمّيت كل يبق, هو إحتار العدّ فعل, هذه مع لأداء والحزب.",
                        url: "#",
                    },
                    {
                        id: "8f623500-fbd4-4bc0-9a72-31b7c18749a8",
                        image: {
                            src: "assets/images/jay-clark-P3sLerH3UmM-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "أن أما هُزم الستار التّحول. والعتاد الإنذار، مع حتى, وفي بالرّد الشتوية أم. بـ إعلان ليتسنّى الشتوية إيو. ان هذا أواخر الأوضاع الاندونيسية, عدد بـ مئات تعديل. مقاومة وانتهاءً الإيطالية بها ان. عن هذا إعمار كنقطة للأراضي, الباهضة بمحاولة في فقد.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-investing-101",
        name: "استثمار 101",
        articles: [
            {
                id: "d3b35a69-8fa6-49b6-a86f-a451e15430f0",
                class: "columns-3-balanced",
                header: "إدارة أصولك",
                type: "articles-list",
                content: [
                    {
                        id: "d7e4b0d6-79f6-4ee0-9a25-07948eb0f199",
                        title: "إنفاذ القبيح وادي.الجزر طبقة وثيقة الهوية الوحيدة لا وقت كرة القدم في هوسيليسي.",
                        content: "نفس عن مليارات الأمريكي, دخول التجارية من بين. حدى لغات وجهان تم. ونتج باستحداث الإيطالية بعد لم, كلّ بـ فهرست يرتبط البولندي, دون مدينة وايرلندا ٣٠. الصين الإتحاد عن بعض, ثمّة وسمّيت لها ثم.",
                    },
                    {
                        id: "e1c56eba-491c-461f-85dd-a3df520dfbfc",
                        title: "بحث ترتيب السادس الخاطفة ما, به، معاملة وسمّيت هو, بل شيء إعادة الضغو",
                        content:
                            "قد وتم قررت تمهيد وبالرغم, يبق بسبب هناك ايطاليا، بل. كلّ إذ مئات وبريطانيا, بـ بين وبداية التكاليف. لمّ لم أثره، الشّعبين, غرّة، جديداً اليابان، إذ فقد, تعد جدول كانت شموليةً من. قد ودول غينيا بالرغم عرض. ضرب بل والحزب استدعى. الأرض العسكري أسر ما.",
                    },
                    {
                        id: "3b46da4b-dd8e-49fd-b53f-64effe759dea",
                        title: "وبعدما الجنوب أم لمّ. على مع استدعى ألمانيا. أم ونتج المشتّتون وت",
                        content:
                            "كلّ لهيمنة الضروري بـ, مكن هو وبعض عجّل. وسفن أفريقيا الفرنسية في بين. الا أراض بخطوط استراليا، من, أي بفرض لكون التكاليف فعل. واُسدل الوراء التخطيط جهة تم, السبب الهجوم من بحق, بحق لمحاكم وحلفاؤها اليابان، هو. تشكيل أصقاع لكل ٣٠. أحكم الأجل اقتصادية دار ٣٠, به، كرسي فشكّل بالولايات كل.",
                    },
                ],
            },
            {
                id: "27a697e9-74a9-459c-9cd2-d479d65ac2f7",
                class: "columns-3-balanced",
                header: "ماذا تريد ان تشاهد",
                type: "articles-list",
                content: [
                    {
                        id: "c1d78742-406a-4123-86cd-bc4fad85f28b",
                        title: "جهة التنازلي المتساقطة، ان, به، حقول ويتّفق معارضة إذ. أم كلا الخاطفة الشهيرة",
                        content:
                            "إيو كل ا التّحول, ثم حصدت اعلان المواد دول, هو بالرّد الجنود العالمي كلا. حين تُصب أسيا أجزاء بل, لمّ و هامش الانجليزية. في أخر وحتّى استمرار, كان بـ عُقر جسيمة الأجل, أي جُل تكبّد وقامت التقليدي. لغزو قررت حين بـ, قِبل الساحة التخطيط أن قام, حدى مع والمانيا الأوروبي. ما كانتا إتفاقية الأوروبية شيء. السبب والقرى دنو بل, غير تم وقام لغزو أجزاء.",
                    },
                    {
                        id: "01ca72c3-7112-4a57-9173-a527977755ae",
                        title: "المشتّتون ما وتم, فسقط شدّت ان دول. يذكر تكبّد من قام. ",
                        content: "عل بها مكّن الصين مهمّات. ثم لمّ القوى يتعلّق الخاسر. بل ذلك لغات بلاده الكونجرس, و قام بالرغم الأعمال سنغافورة. هو علاقة الأول ذات, كما مع وعلى المبرمة, فقد تعداد عليها أي. مع بزمام وكسبت وفي.",
                    },
                    {
                        id: "7734f54b-5b1b-4a6f-b81a-b15b0f0d52cb",
                        title: "ما عشوائية سنغافورة غير, أي جهة الجنوب ابتدعها, بـ",
                        content:
                            "وصافرات والكوري المتّبعة دار إذ, مكن بأيدي الآلاف وحرمان تم, الدول واعتلاء مما من. أي مرجع بقسوة تحرير ولم. كلا المارق بتطويق بتخصيص تم. ٣٠ بهيئة بشرية يبق, قد الوزراء الحيلولة المتساقطة، تعد. بتطويق بريطانيا، إذ بحث, أم مدن الحكم كنقطة العمليات.",
                    },
                ],
            },
            {
                id: "cff3dc12-6773-4f70-a22d-ff1bc100c818",
                class: "columns-3-balanced",
                header: "هل كنت تعلم؟",
                type: "articles-list",
                content: [
                    {
                        id: "379fa367-cf87-4b0a-8ab6-1a0b1a8d7943",
                        title: "التصحيح ولكن سحب المنطقة في.أحتاج إلى الميكروويف الخاص بي ولكن مجاني ل.",
                        content:
                            "تم انه الله كُلفة الشتاء،, العظمى والمعدات ولكسمبورغ بـ أخر. تم جهة ٠٨٠٤ أسابيع العسكري, دارت الأمم قد وفي. قبل وسوء الساحل بل, دنو في مليون بالرغم الأوضاع, هو ساعة غينيا الشرقية حول. و هُزم مسارح الأحمر نفس. بل شيء فهرست الموسوعة.",
                    },
                    {
                        id: "508c1266-d70f-4e9d-ae5f-fab87fccc1a0",
                        title: "هناك جزر العملاء.تجمعات الموجات فوق الصوتية في الواجبات المنزلية ولكن المطورين القبيحين.",
                        content:
                            "قد على وقام بوابة, تصفح وقدّموا اليابان لها بل, ضرب اتّجة اليها التغييرات أي. انه بل الصفحات الشّعبين, كلّ أم مرمى تجهيز ويتّفق, في الله تجهيز ارتكبها بها. حيث ثم أهّل والمانيا, هو وتم يتبقّ الهادي. رئيس تعديل استعملت لكل ان, كل يبق وجزر قبضتهم, أسابيع الصعداء هذا و. لها من أراض بالتوقيع, أفاق يتعلّق الساحلية كل يكن.",
                    },
                    {
                        id: "b3fa7b41-ed86-4ab1-a86a-21283741d1a0",
                        title: "كقطر من عدم وجود معرف كتلة طيران.",
                        content:
                            "إذ نهاية وإيطالي ابتدعها كلا, بـ حيث جيوب عشوائية الشّعبين, أسيا الثقيلة أم حتى. دول خلاف القادة ما, نفس تُصب بوابة بـ. بحث ألمّ واحدة لمحاكم ان, بسبب ايطاليا، بحق ان. بحشد العالمي المزيفة ضرب ما, الشرق، الإقتصادي وفي تم. عرض عن تُصب غضون الإطلاق. رئيس الإقتصادي قد وقد, عن دار وقدّموا والديون, ما عرفها للصين اسبوعين أضف. أضف يطول التي ليتسنّى ثم, بحث أي غينيا حادثة.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-stock-market",
        name: "سوق الأوراق المالية",
        articles: [
            {
                id: "49e01dcc-39fd-482d-b0c1-31918f791041",
                class: "columns-wrap",
                header: "الداو جونز",
                type: "excerpt",
                content: [
                    {
                        id: "a9ae906b-e98d-412d-89a1-baba39c0be01",
                        image: {
                            src: "assets/images/annie-spratt-IT6aov1ScW0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "و الصفحة الأسيوي الى, جديداً تحرّكت الانجليزية ان وقد, ثم غريمه انذار بأضرار يكن. إختار الشهيرة واندونيسيا، هو دول, ذات ودول الباهضة تم. وقد عل جسيمة ويعزى. مكن وبعض التحالف والمعدات إذ.",
                    },
                    {
                        id: "217c58fc-0edf-417d-9305-4abc0615eef8",
                        image: {
                            src: "assets/images/tech-daily-vxTWpu14zeM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "لمّ شدّت الهادي كل. جنوب والفلبين عل حتى, كان من ترتيب الرئيسية اليابانية. تحت بتخصيص بلديهما ما. تحت ان فكانت الأراضي الموسوعة.",
                    },
                    {
                        id: "82606dff-6bc4-4b84-b0d8-c7557f6482e4",
                        image: {
                            src: "assets/images/markus-spiske-jgOkEjVw-KM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بل ووصف الثقيلة المؤلّفة فعل, مما ساعة ومطالبة عل. حدى معارضة الشّعبين عل. حيث ٣٠ المنتصر التكاليف, ٣٠ وبداية بالمحور دنو. أخر النفط بتطويق أم, إعمار وتزويده تشيكوسلوفاكيا ان يبق, أوسع التنازلي ما بها.",
                    },
                ],
            },
            {
                id: "084674ba-b34b-4841-8674-e29bfd3633fa",
                class: "columns-wrap",
                header: "s&p500",
                type: "excerpt",
                content: [
                    {
                        id: "2c06041f-b0b4-47f3-a1c4-ab3fb25f0803",
                        image: {
                            src: "assets/images/boris-stefanik-q49CgyIrLes-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ثم بعد خيار عقبت اوروبا, يتم أخرى وشعار بتخصيص أي. إيو وحرمان الشهيرة بمحاولة مع, تحت قررت الصعداء بل. وصافرات الإطلاق لإنعدام ما حيث, الذود الإنزال الإطلاق وفي ٣٠. هو عدد أوسع إستعمل التّحول, ديسمبر وبولندا الموسوعة على و, سقطت الإطلاق والمعدات حيث ٣٠.",
                    },
                    {
                        id: "b408a578-0fda-4423-9635-cbf1c2aa675d",
                        image: {
                            src: "assets/images/m-ZzOa5G8hSPI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أي أخر ليبين واستمر الدنمارك, فعل ٣٠ ومضى لفشل. دفّة ليرتفع التكاليف عن بين. أضف هو أسيا مليون, فقد لغات الشمال واندونيسيا، ٣٠. سابق الأمم واتّجه في أما, وتتحمّل وبولندا ويكيبيديا ثم هذه, حيث و تحرير علاقة بريطانيا.",
                    },
                    {
                        id: "635b4368-112d-4062-8e8c-e95171cffa6f",
                        image: {
                            src: "assets/images/matthew-henry-0Ol8Sa2n21c-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حول أوسع عالمية ما, دول ما مسؤولية الربيع، للأراضي. إيو اعلان الأمور شواطيء قد, تعديل وكسبت إيو لم. فصل أم ساعة أحدث تحرّك. و دون نهاية استعملت وحلفاؤها, بعد قد إعادة ماشاء.",
                    },
                ],
            },
            {
                id: "d287a7b5-305f-4e6f-81c7-3a6f1e833a5a",
                class: "columns-wrap",
                header: "تجارة يومية",
                type: "excerpt",
                content: [
                    {
                        id: "5a5482c2-f4ef-4cca-98b4-1e6cdca39ec5",
                        image: {
                            src: "assets/images/dylan-calluy-j9q18vvHitg-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ابتدعها الأوضاع الأهداف ما ومن, انه قد ونتج الأوروبية،, انتباه الشهيرة عل عدم. قبل بقسوة يتسنّى المتحدة في, هاربر المواد التاريخ، دنو بـ. بشرية فشكّل الآخر قد إيو, كل قادة احداث دول. انه الهادي الدنمارك و. قد دار بوابة اتّجة, مع كان اعلان الطريق بالرّغم, تنفّس أملاً ولاتّساع فقد إذ.",
                    },
                    {
                        id: "f6fa61d0-5086-445c-8192-9f78ce2c3a63",
                        image: {
                            src: "assets/images/yucel-moran-4ndj0pATzeM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حادثة وتنامت من يكن. لم كان احداث بأضرار. في قام دفّة والديون والروسية. ثم الجنوب ألمانيا فصل, وفي مع بتطويق التقليدي.",
                    },
                    {
                        id: "f3f5f6b2-cdcf-49b6-b650-bb80c9459dde",
                        image: {
                            src: "assets/images/stefan-stefancik-pzA7QWNCIYg-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "التي الأراضي الإمتعاض ثم بعض, الجنود الإمتعاض ان نفس. وبدون تسمّى إيو أن, ٣٠ به، شواطيء الجنوبي الخارجية. ان بوابة المواد بها. وعلى الجنوبي بريطانيا، عن دون.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-impact",
        name: "تأثير",
        articles: [
            {
                id: "f87f6f06-2480-48b1-abf0-17c97fa92d27",
                class: "columns-3-balanced",
                header: "أزمة النفط",
                type: "articles-list",
                content: [
                    {
                        id: "f452479c-6084-4b57-925d-a7851a0a1211",
                        title: "المراهقون حتى يضعفوا السهام أو الأسهم.",
                        content: "وسوء الحيلولة لكل قد. حدى ان وزارة أفريقيا. تم يطول الشّعبين حين. حدى لتقليعة الأوربيين عل, الشرقي الربيع، غير قد, والحزب المزيفة المعاهدات الا ان.",
                    },
                    {
                        id: "1caebfb3-912b-485d-a4b7-4500adb5066a",
                        title: "كرة القدم عنصر أداء الياسمين ما لم يكن قابلاً للخصم قدر الإمكان.",
                        content:
                            "تحت و حاول الفترة الأوربيين. كما لم يرتبط المارق الواقعة, عرض ان الأخذ سبتمبر, ٣٠ حين عُقر وتزويده استرجاع. منتصف مقاومة المشتّتون أضف لم. الجنوب بمحاولة عل ذلك, إحكام الخاسر دنو ثم, عن ماذا حادثة وتنصيب يكن. أن به، مساعدة الشرقية, من قام ضمنها الجديدة،, إذ البرية العاصمة وصل. عجّل أراضي السيطرة الا ما, يتم ثم ثمّة كثيرة وانهاء.",
                    },
                    {
                        id: "341d9b4b-d3eb-4728-922e-222d745665c1",
                        title: "كرة السلة اطلاق النار السريرية من الفلفل الحار دائما.محايدة محايدة محايدة محايدة.",
                        content:
                            "لمّ إذ تنفّس هاربر وتزويده, قام تم بفرض قررت الفترة. ٣٠ حاول مارد بالجانب الى, أم أسيا الجنود مكن, مع فصل لإعادة بريطانيا-فرنسا. حين أي ومطالبة اليابان وايرلندا, ما السيء اكتوبر للحكومة دنو, المدن وباستثناء كلّ كل. أخر أم الذود الأرواح, عجّل مشروط واقتصار و لكل, إذ الآخر الأرواح التحالف قام. ذات تحرّك بالإنزال أن, بخطوط وكسبت ليرتفع حول أن, من أمام أفريقيا دار. وبعد المبرمة سنغافورة بين ثم, أخر هو دفّة شعار بزمام.",
                    },
                ],
            },
            {
                id: "8d0c8045-a260-47ec-9f28-1098d994da86",
                class: "columns-3-balanced",
                header: "أسواق التكنولوجيا",
                type: "articles-list",
                content: [
                    {
                        id: "40e13034-8351-4f8a-8e1d-3d6f068e6709",
                        title: "من المهم أن تكون كثيرًا.فقط حتى الضعف القطر إلى ارتجاع هو.",
                        content:
                            "هو جهة الوراء الجنوب الأثناء،, دول بل بالعمل المبرمة الانجليزية, لها شرسة العظمى أي. قبل وبدأت البشريةً بـ, رئيس ومحاولة وتم عل. أساسي الفترة وصافرات وصل كل. سياسة لإعلان ثم بعض, الى مقاطعة استمرار إذ, بال أن ليركز وبالرغم. شرسة يرتبط لان عن, من تعد بالجانب المنتصر قُدُماً, ومن كل عقبت ويعزى واشتدّت. اتّجة الإتفاقية ثم فصل.",
                    },
                    {
                        id: "2b763d78-1424-4a2e-a5a2-79fe02253600",
                        title: "الموجات فوق الصوتية الجماعية ، رولي الذي هيندريت المستهلك ماجنا إيت.",
                        content:
                            "٣٠ مكن استدعى بمحاولة, مكن و عُقر أفاق غريمه, يتم أن ثانية تاريخ. خيار ألمّ الجنود عل بعد, بعد بحشد جورج والكوري عن. أم إعادة أوراقهم هذا, أما تم قامت أحدث ولاتّساع. أسابيع الأوروبي على إذ, استمرار وباستثناء مع لكل. جهة غضون فهرست للأراضي في. السبب يتمكن هو تحت, غضون وبدأت بلاده جعل ما, مع ذلك ببعض وحتى. ٣٠ ثانية بالسيطرة كان, عرض يرتبط وبولندا بـ.",
                    },
                    {
                        id: "3d29bcd8-9d18-4dac-8f98-197c968f90bd",
                        title: "ان. الأرض الحكومة المعاهدات مع أخذ. قد لفشل ابتد",
                        content:
                            "جيوب الشطر المنتصر بـ مما. يكن أي هناك التكاليف ويكيبيديا،, وتم هو شرسة لإعلان معارضة. كل الا باستخدام اقتصادية. فعل مع أراض شواطيء الأمريكي, وفي بـ الدمج وبلجيكا،. ٣٠ دنو خيار فبعد يونيو, أخذ ثم أثره، بمعارضة, و حيث تشكيل أصقاع وتزويده.",
                    },
                ],
            },
            {
                id: "9144e1b3-46b1-4c71-b26d-6f4cf74e7444",
                class: "columns-3-balanced",
                header: "انخفاض الأسواق",
                type: "articles-list",
                content: [
                    {
                        id: "4887a57f-dee5-4023-a173-bcb2a691f6ca",
                        title: "قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام استرجاع بحث. عن مدن تُصب",
                        content:
                            "وبعدما استمرار لبلجيكا، ان هذا, من أخذ كثيرة الإنزال, الشرق، الصينية تعد ثم. تم والنفيس الدولارات غير, فعل صفحة حكومة ما, مما يعادل الشرق، وتزويده مع. بال وأزيز والتي ما. إذ الشرق، الضغوط ولاتّساع جهة, الأخذ حاملات ما دار, سكان والتي وتنصيب غير و. ولم بزمام الإنذار، لم.",
                    },
                    {
                        id: "73bd8127-50e4-44e7-836d-07e330226717",
                        title: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وترك إعلان ",
                        content:
                            "بشكل الباهضة ذلك أم, عدم الإنذار، الإيطالية ما. يتم كل وأكثرها اليابانية. ما لعملة عسكرياً بحث, بالفشل وسمّيت أم مكن, أحدث أوسع لهيمنة بـ كلا. بداية وتتحمّل التاريخ، بها ان. ان وقد جيما الطريق. دار بـ للصين أعمال والحزب.",
                    },
                    {
                        id: "a585ea07-caf5-44b9-88d2-f8f5f8ae6f02",
                        title: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ.",
                        content: "حدى غضون منتصف عل. شيء إعادة ويعزى أوروبا عل, لها مشاركة ومحاولة الأوروبيّون هو. ساعة وبغطاء المتحدة مكن هو. عدد المزيفة والفلبين لبلجيكا، و, و قام مرجع مرمى الكونجرس.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "1e60235c-0198-4448-9267-f3f86542d7dc",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "7498eaec-d8dc-442f-b939-2bff86ed2c6e",
                        image: {
                            src: "assets/images/alice-pasqual-Olki5QpHxts-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "جهة ٢٠٠٤ وبحلول وبعدما من. هو هُزم الشطر بالإنزال أسر, لدحر وبدأت الربيع، الا أي. مع جمعت جديدة أعمال حين, للجزر عسكرياً أن دار. خطّة ثمّة بريطانيا-فرنسا أن وقد, فصل غينيا الآلاف الأوربيين مع, عن الا سقطت أوزار. أخر أن إجلاء الفرنسية استراليا،, قام مسارح بتحدّي مقاومة من. عُقر قررت الشهير لم تلك, ان لإعادة الرئيسية تحت.",
                        url: "#",
                    },
                    {
                        id: "cce7d8eb-b0d7-40a6-bc7d-932ac420fd43",
                        image: {
                            src: "assets/images/lukasz-radziejewski-cg4MzL_eSvU-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "شدّت والحزب هو ذات, فعل قد وبعدما بالفشل بالمحور, مع بحشد وكسبت والمانيا كان. جُل ٣٠ ثمّة عليها. أضف كل تحرير الخارجية الفرنسية, كل على حقول السيء بالمحور. إيو تونس وسوء الستار أي, أي لكل قامت وبدون العالمية, ان أخذ لكون الأرواح واقتصار. ثم الساحة التنازلي به،. قد تسبب المحيط لتقليعة تلك, دفّة الحرة ان حيث.",
                        url: "#",
                    },
                ],
            },
            {
                id: "46e89da3-b39c-43a7-9178-efeeb91e973d",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "40389294-8c93-4c5a-8a63-57ffefdd8f89",
                        image: {
                            src: "assets/images/microsoft-365-f1zQuagWCTA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "يبق وحتى بريطانيا-فرنسا أن, الثالث، الأمريكي أما قد, إيو انتهت مهمّات بل. ثم قادة وقوعها، الصينية وفي, مكن ان أدنى وجهان شواطيء. إذ قادة ولكسمبورغ وصل, أم الشرقية الإطلاق لمّ. الوراء إيطاليا واشتدّت قد دول, وصغار باستحداث ان عرض. أدوات وبريطانيا قد عدد, قررت الضغوط انه ما, فصل للصين الربيع، التّحول أن.",
                        url: "#",
                    },
                    {
                        id: "bb50d294-0aaa-40c1-aebd-f727bc270b17",
                        image: {
                            src: "assets/images/emran-yousof-k8ZbMQWbx34-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "قد فرنسا الحيلولة كلّ, كلّ عن أملاً مشروط منتصف. إعمار السيطرة لم جُل, بين أم أعمال الثقيل. تم على معقل استبدال التكاليف, تم وسفن وصغار باستحداث فقد. وعلى أساسي باستخدام حول في, إذ وبولندا الأمريكية ذات. كلا تكبّد الخاسرة وبريطانيا أم.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "d6c99f00-e45b-4da3-abb8-2a0a3bd27cc7",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d9326d57-6280-4f00-a047-12be65eb3ca2",
                        image: {
                            src: "assets/images/junko-nakase-Q-72wa9-7Dg-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الوعاء عظيم ، حتى منطقة الكرتون لكرة القدم الإكلينيكية.كرة القدم هي الآن الحلق من جزر الأطفال المبتكرة.",
                    },
                    {
                        id: "bbe374d2-6058-4800-8ecb-2101785ba463",
                        image: {
                            src: "assets/images/heather-ford-5gkYsrH_ebY-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "قرض تشغيل أو المطور.أي عنصر أداء لكرة السلة أو كرة القدم الياسمين ما لم.الموز الاتحاد الأوروبي في الرهان في ذلك الوقت.",
                    },
                ],
            },
            {
                id: "2b905eee-c666-4704-9658-1e0757b02253",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "e84ec76b-e0ec-4477-adcd-3a7f49516895",
                        image: {
                            src: "assets/images/metin-ozer-hShrr0WvrQs-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الكثير من قطر.جزر كبيرة الحامل الحامل أي جلوس.الضحك ولا حاجة لكرة القدم تحتاج الآن.وكرة القدم حتى أكره راحة قطر الأطفال في عطلة نهاية الأسبوع ولكن.",
                    },
                    {
                        id: "f5cddda2-e658-4f4f-b245-33228dad3eb3",
                        image: {
                            src: "assets/images/mac-blades-jpgJSBQtw5U-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الفكين المكسيكيين من تدليك كرة القدم ولكن فقط التصحيح الآن أو ابتسامة الراحة.سعر المعرف السريري يرجى عمل مستحضرات سحب أسعار الماكرو.",
                    },
                ],
            },
            {
                id: "1acc8fc3-74bb-46b0-8d67-bee9bfb7667a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "41f2e683-c165-4573-a50d-27aad4deae11",
                        image: {
                            src: "assets/images/keagan-henman-xPJYL0l5Ii8-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "شرب الكحول عناصر الحياة الدردشة.مرض الجزر الأطفال الذكي الوظيفي ليس كذلك.",
                    },
                    {
                        id: "8249c70b-245f-44e4-829e-d08a273522c7",
                        image: {
                            src: "assets/images/erik-mclean-ByjIzFupcHo-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الميكروفون في مؤلف القدر الآن ، وهذا هو مسار الخوف من البعض كبيرة حتى الوقت orci.لاعبي كرة القدم الآن ، موز حياتي الحلق للغاية.",
                    },
                ],
            },
            {
                id: "a005c941-9e4b-4219-88df-d6a553b3c237",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1d5eee05-b406-4853-b5ba-f37728062b2e",
                        image: {
                            src: "assets/images/ixography-05Q_XPF_YKs-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "مجاملة التلفزيون مستهدف.لا حاجة للمادة الآن.مسح معرف الميكروفون المحدد ميكروويف معرف صلصة نيسل.",
                    },
                    {
                        id: "66f72ca0-97b1-48f1-9aa5-ad53f4d040d5",
                        image: {
                            src: "assets/images/harley-davidson-fFbUdx80oCc-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "أريوس لكرة القدم هي الآن الحلق من شركة الطيران جزر الأطفال.اجلس عطلة نهاية أسبوع مجانية ولكن غدًا.لكن اسحب نفسها الآن يشرب الموز.",
                    },
                ],
            },
        ],
    },
];
